import { AxiosResponse } from 'axios';
import { messagesReconnect } from 'common/modules/ReactShared';
import { updateAuthTokens } from '../utils';
import { getApi } from '../apiClient';

import {
  IStudentMailSignInRequest,
  IStudentMailSignInResponse,
  IStudentMailSignUpRequest,
  IStudentVerifyOTPRequest,
  IStudentSignOutResponse,
  IInvitationResponse,
  IAcceptInvitationRequest
} from './types';

export async function mailSignIn(
  student: IStudentMailSignInRequest['student']
): Promise<IStudentMailSignInResponse['profile']> {
  const {
    data: { profile, authenticityToken }
  } = await getApi().post<IStudentMailSignInResponse>(`/students/sign_in`, {
    student
  });

  updateAuthTokens({ csrf: authenticityToken });

  messagesReconnect(profile.id);

  return profile;
}

export async function mailSignUp(
  student: IStudentMailSignUpRequest['student']
): Promise<void> {
  await getApi().post(`/students/sign_up`, {
    student
  });
}

export async function getOTP(
  student: IStudentVerifyOTPRequest['student']
): Promise<void> {
  await getApi().post(`/students/otp`, {
    student
  });
}

// If no data is returned - Axios returns an empty string ""
export async function signOut(): Promise<void> {
  const {
    data: { authenticityToken }
  } = await getApi().post<IStudentSignOutResponse>(`/students/sign_out`);

  updateAuthTokens({ csrf: authenticityToken });

  messagesReconnect();
}

export async function checkInvitation(
  inviteId: string
): Promise<IInvitationResponse | null> {
  const { data } = await getApi().get<IInvitationResponse>(`/invitations/${inviteId}`);

  return data;
}

export async function acceptInvitation(
  params: IAcceptInvitationRequest
): Promise<AxiosResponse<void>> {
  const { inviteId, ...student } = params;

  return getApi().post<void>(`/invitations/${inviteId}/accept`, student);
}
